import {call, put, takeLatest, fork, all, delay,} from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as GolfService from './../services/golfService';
import { setGolfDetail as setGolfDetailAction } from './../actions/golfAction';
import i18n from '../constants/initLng';
import * as Func from "../helpers/functions";
import {PATHS, SAGA_DELAY_TIMEOUT} from '../constants/Define';
import { parseListRequestParamsPageNumber } from '../utils/commonUtils';
import { setListGolf } from './../actions/golfAction';
import history from './../helpers/history';

function* getListGolf() {
    yield takeLatest(Types.GOLF_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParamsPageNumber(action.filters || {});
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(GolfService.getGolfs, params);
        yield put(setListGolf(result));
    }, errorHandleGolf(Types.GOLF_LIST_FAIL)))
} 

function* getGolfDetail() {
    yield takeLatest(Types.GOLF_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(GolfService.getGolfDetail, action.id);
        yield put({ type: Types.GOLF_DETAIL_SUCCESS, golf: result });
    }, errorHandleGolf(Types.GOLF_DETAIL_FAIL)))
}

function* updateGolfDetail() {
    yield takeLatest(Types.GOLF_DETAIL_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(GolfService.updateGolfDetail, action.golf);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.updateSuccess')}`, description: `${i18n.t('item.golf.title')} "${action.golf.name}"` })
        yield put(setGolfDetailAction(action.golf));
        yield put({ type: Types.GOLF_DETAIL_ACTION, id: action.golf.id });
    }, errorHandleGolf(Types.GOLF_FAIL)))
}

function* createGolfTranslate() {
    yield takeLatest(Types.GOLF_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(GolfService.createGolfTranslate, action.golf, action.language);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.createSuccess')}`, description: `${i18n.t('item.golf.title')} "${action.golf.name}"` })
        yield put({ type: Types.GOLF_DETAIL_ACTION, id: action.golf.id });
    }, errorHandleGolf(Types.GOLF_FAIL)))
}

function* updateGolfTranslate() {
    yield takeLatest(Types.GOLF_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(GolfService.updateGolfTranslate, action.golf, action.language);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.updateSuccess')}`, description: `${i18n.t('item.golf.title')} "${action.golf.name}"` })
        yield put({ type: Types.GOLF_DETAIL_ACTION, id: action.golf.id });
    }, errorHandleGolf(Types.GOLF_FAIL)))
}

function* deleteGolfTranslate() {
    yield takeLatest(Types.GOLF_DELETE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(GolfService.deleteGolfTranslate, action.golf, action.refreshParams);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.deleteSuccess')}`, description: `${i18n.t('item.golf.title')} "${action.golf.name}"` })
        yield put({ type: Types.GOLF_DETAIL_ACTION, id: action.golf.id });
    }, errorHandleGolf(Types.GOLF_FAIL)))
}

function* updateGolfOrder() {
    yield takeLatest(Types.GOLF_UPDATE_ORDER_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(GolfService.updateGolfOrder, action.data);
        Func.sagaSuccessMessage({ 
            action, 
            message: `${i18n.t('notification.updateSuccess')}`, 
            description: `${i18n.t('item.golf.updateOrder')}` 
        });
        // Tải lại danh sách golf sau khi cập nhật thứ tự
        yield put({ type: Types.GOLF_LIST_ACTION, params: { pageSize: 10, pageNumber: 1 } });
    }, errorHandleGolf(Types.GOLF_FAIL)))
}

function errorHandleGolf(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'golf');
}

function* syncAllGolf() {
    yield takeLatest(Types.RATE_SYNC_ALL_GOLF_ACTION, Func.sagaWrapper(function* (action) {
        yield call(GolfService.syncAllGolf);
        Func.sagaSuccessMessage(action, i18n.t('validation.syncSuccess'));
        yield put({ type: Types.RATE_SYNC_ALL_GOLF_SUCCESS });
        const filters = action.filters || {};
        yield put({ type: Types.GOLF_LIST_ACTION, params: { pageSize: 10, pageNumber: 1 }  });
    }, errorHandleGolf(Types.GOLF_FAIL)))
}

export function* golfSaga() {
    yield all([
        fork(getListGolf),
        fork(getGolfDetail),
        fork(updateGolfDetail),
        fork(createGolfTranslate),
        fork(updateGolfTranslate),
        fork(deleteGolfTranslate),
        fork(updateGolfOrder),
        fork(syncAllGolf),
    ])
}
